import { merge } from 'lodash';
import Resource from 'Resources/Resource';
import type UserModel from 'App/resources/Model/User';
import AppService from 'App/legacy/AppService';
import EventBus from 'App/services/EventBus';

class User extends Resource {
	constructor() {
		super('users', null, { notificationTitle: 'default.user' });
	}

	async update(data: Partial<UserModel>) {
		const res = await this.save(data, { _url: `master/users` });

		const self = AppService.getSelf();
		if (data.id === self.id) {
			EventBus.broadcast('self.updated', merge(self, res.data));
		} else {
			const userMap = AppService.getUserMap();
			const saved = res.data;
			// Same membership rules as api/src/controller/customer/user.js
			const belongsIn = (type: string) => {
				switch (type) {
					case 'deleted':
						return !saved.active && !saved.ghost;
					case 'active':
						return !!saved.active;
					case 'inactive':
						return !!saved.ghost;
					default:
						return !!(saved.active || saved.ghost);
				}
			};
			const nextUserMap = Object.entries(userMap).reduce<typeof userMap>((result, [type, users]) => {
				if (!belongsIn(type)) {
					result[type] = users.filter(user => user.id !== data.id);
				} else if (users.some(user => user.id === data.id)) {
					result[type] = users.map(user => (user.id === data.id ? merge(user, saved) : user));
				} else {
					result[type] = [...users, saved];
				}
				return result;
			}, {});

			AppService.setUserMap(nextUserMap);
			await new Promise(resolve => setTimeout(resolve, 0));
		}
	}
}

const resource = new User();

export default resource;
